import { constructUrl } from '@ynap/url-configuration';

export default function getProductLinkByPartNumber(pdpUrlTemplate, locale, seo, partNumber) {
    const seoPath = seo?.seoURLKeyword || `/${partNumber}`;

    const [language, country] = locale?.split('-') || []; // NAP Early rollout enable old style PDP links /gb/en/product/123456

    if (pdpUrlTemplate && locale) {
        return constructUrl(pdpUrlTemplate, {
            LOCALE: locale,
            SEO_URLKEYWORD: seoPath,
            COUNTRY: country,
            LANGUAGE: language,
            PART_NUMBER: partNumber,
        });
    } else {
        return undefined;
    }
}
